import { NgZone } from '@angular/core';

export class AONodeItem {

  data: any;

  level: number = 0;

  children: AONodeItem[];

  expanded: boolean = false;

  isExpanded() {
    return this.expanded;
  }

  isExpandable() {
    return this.children.length > 0;
  }

}

export class AOTreeHelper {

  private map: Map<any, AONodeItem> = new Map<any, AONodeItem>();

  private tree: AONodeItem[] = [];

  constructor(
    private _zone: NgZone
  ) {
  }

  //--------------------------------------------------------------------------------------------------------------------
  // STATIC METHODS
  //--------------------------------------------------------------------------------------------------------------------

  static listToTree(items, map?: Map<any, AONodeItem>, fk_name = 'parent_id', pk_name = 'id') {
    //
    // inicializa o map, se ainda nao tiver sido inicializado
    //
    if (map == undefined) {
      map = new Map<any, AONodeItem>();
    }

    //
    // funcao para criar todos os nodes necessarios
    //
    const create = (data) => {
      let node = map.get(data[pk_name]);

      if (node == undefined) {
        node = new AONodeItem();
      }

      node.data = data;
      node.children = [];

      map.set(data[pk_name], node);

      return node;
    };

    //
    // aninha todos os nodes do map
    //
    const nest = (root: any[], node: any) => {
      const parent = node.data[fk_name] ? map.get(node.data[fk_name]) : undefined;

      if (parent) {
        node.level = parent.level + 1;
        parent.children.push(node);
      } else {
        root.push(node);
      }

      return root;
    };

    return {
      map, tree: items.map(create).reduce(nest, [])
    };
  }

  static flatTree(tree: AONodeItem[]) {
    const flat = (nodes: any[], node: any) => {

      nodes.push(node);

      return node.children.length > 0
        ? node.children.reduce(flat, nodes)
        : nodes;

    };

    return tree.reduce(flat, []);
  }

  //--------------------------------------------------------------------------------------------------------------------
  // OBJECT METHODS
  //--------------------------------------------------------------------------------------------------------------------

  setItems(items) {
    this._zone.run(() => {

      const response = AOTreeHelper.listToTree(items, this.map);

      this.map = response.map;
      this.tree = response.tree;

    });
  }

  getRoot(): AONodeItem[] {
    return this.tree;
  };

  getChildren(node?: AONodeItem): AONodeItem[] {
    return node ? node.children : this.getRoot();
  };

  getDescendants(node?: AONodeItem): AONodeItem[] {
    return AOTreeHelper.flatTree(node ? node.children : this.getRoot());
  };

  getParent(node: AONodeItem): AONodeItem | undefined {
    return this.map.get(node.data.parent_id);
  }

  getParents(node: AONodeItem): AONodeItem[] {
    const parent = this.getParent(node);
    return parent ? [parent, ...this.getParents(parent)] : [];
  }

  getBrothers(node?: AONodeItem): AONodeItem[] {
    const parent = this.getParent(node);
    return parent ? parent.children : this.getRoot();
  }

  isVisible(node: AONodeItem) {
    const parent = this.getParent(node);
    return parent ? parent.expanded : true;
  }

  tootle(node: AONodeItem) {
    if (node.expanded) {
      [node, ...this.getDescendants(node)].map(n => n.expanded = false);
    } else {
      node.expanded = true;
    }
    return node.expanded;
  }

  expandAll() {
    this.getDescendants().map(n => n.expanded = true);
  }

  contractAll() {
    this.getDescendants().map(n => n.expanded = false);
  }

  getNextOrder(node?: AONodeItem) {
    const children = this.getChildren(node);
    return children.length === 0 ? 0 : children.slice(-1)[0].data.order + 1;
  }

  getNavigate(node: AONodeItem): { previous: AONodeItem | null, current: AONodeItem, next: AONodeItem | null } {
    const brothers = this.getBrothers(node);

    const locate = (navigate, item, index) => {
      if (node.data.id === item.data.id) {
        navigate.previous = index > 0 ? brothers[index - 1] : null;
        navigate.next = index < brothers.length ? brothers[index + 1] : null;
      }
      return navigate;
    };

    return brothers.reduce(locate, {previous: null, current: node, next: null});
  }

  getPrevious(node: AONodeItem) {
    return this.getNavigate(node).previous;
  }

  getNext(node: AONodeItem) {
    return this.getNavigate(node).next;
  }

  //--------------------------------------------------------------------------------------------------------------------
  //
  //   import { SelectionModel } from '@angular/cdk/collections';
  //
  //--------------------------------------------------------------------------------------------------------------------
  //
  //   selection = new SelectionModel<AONodeItem>(true /* multiple */, []);
  //   onSelected = new EventEmitter<any>();
  //
  //   isSelected(node: AONodeItem): boolean {
  //     return this.isExpandable(node)
  //       ? this.treeControl.getDescendants(node).every(child => this.selection.isSelected(child))
  //       : this.selection.isSelected(node);
  //   }
  //
  //   isPartiallySelected(node: AONodeItem): boolean {
  //     return this.isExpandable(node)
  //       ? this.treeControl.getDescendants(node).some(child => this.selection.isSelected(child)) && !this.isSelected(node)
  //       : false;
  //   }
  //
  //   nodeChange(node: AONodeItem) {
  //     this.selection.toggle(node);
  //
  //     if (this.isExpandable(node)) {
  //       const descendants = this.treeControl.getDescendants(node);
  //       this.selection.isSelected(node) ? this.selection.select(...descendants) : this.selection.deselect(...descendants);
  //       descendants.every(child => this.selection.isSelected(child)); // Force update for the parent
  //     }
  //
  //     this.checkAllParentsSelection(node);
  //
  //     this.selected.emit(
  //       this.selection.selected.reduce((items, node: AONodeItem) => items.concat({...node.data}), [])
  //     );
  //   }
  //
  //--------------------------------------------------------------------------------------------------------------------
  //
  //   /** Checks all the parents when a leaf node is selected/unselected */
  //   checkAllParentsSelection(node: AONodeItem): void {
  //     let parent: AONodeItem | undefined = this.getParent(node);
  //
  //     while (parent) {
  //       this.checkRootNodeSelection(parent);
  //       parent = this.getParent(parent);
  //     }
  //   }
  //
  //   /** Check root node checked state and change it accordingly */
  //   checkRootNodeSelection(node: AONodeItem): void {
  //     const nodeSelected = this.selection.isSelected(node);
  //     const descAllSelected = this.treeControl.getDescendants(node).every(child => this.selection.isSelected(child));
  //
  //     if (nodeSelected && !descAllSelected) {
  //       this.selection.deselect(node);
  //     } else if (!nodeSelected && descAllSelected) {
  //       this.selection.select(node);
  //     }
  //   }
  //
  //--------------------------------------------------------------------------------------------------------------------

}

